interface AppConfig {
  VITE_SEARCH_API_BASE_URL: string;
  VITE_SEARCH_API_KEY: string;
  VITE_API_BASE_URL: string;
  VITE_ENVIRONMENT: string;
  VITE_VERSION: string;
  [key: string]: unknown; // Allow other properties
}

// This object will hold the configuration once it's loaded.
let appConfig: AppConfig | null = null;

// Default values are useful for local development, providing a fallback.
const defaults: AppConfig = {
  VITE_SEARCH_API_BASE_URL: "http://localhost:7700",
  VITE_SEARCH_API_KEY: "your-local-dev-api-key",
  VITE_API_BASE_URL: "http://localhost:3001/api/v1",
  VITE_ENVIRONMENT: "development",
  VITE_VERSION: "1.0.0",
};

export const fetchConfig = async (): Promise<void> => {
  try {
    // In a deployed environment, fetch the config file.
    const response = await fetch("/config.json");
    if (!response.ok) {
      throw new Error(
        "Config file not found or failed to load. Using defaults."
      );
    }
    const configFromFile = await response.json();
    appConfig = { ...defaults, ...configFromFile };
    console.log(
      `Configuration loaded successfully for environment: ${appConfig?.VITE_ENVIRONMENT}`
    );
  } catch (error) {
    // For local development, the fetch will fail. We fall back to the defaults.
    console.warn(
      "Could not load remote config, falling back to local default values:",
      error
    );
    appConfig = defaults;
  }
};

/**
 * A getter function to access the loaded configuration.
 * It's crucial that this is only called after `fetchConfig` has completed.
 * @returns The application configuration object.
 */
export const getFetchedConfig = (): AppConfig => {
  if (!appConfig) {
    // This is a safeguard. The app's entry point should prevent this.
    console.error(
      "Config has not been fetched yet! Returning defaults, but this is an error."
    );
    return defaults;
  }
  return appConfig;
};
